import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetUserActivities(id: string | undefined) {
  return useQuery(queries.users.getUserActivitiesById(id || ''))
}
